import { notification } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from 'recharts';

import { formatarData } from '../../../../../helpers/data';
import apiNetCore from '../../../../../services/apiNetCore';
import { Spin } from '../../../../../styles/global';
import {
  ChartLegend,
  Container,
  LegendsContainer,
  LoadingContainer,
  NoDataContainer,
} from './styles';

const CarregamentosGraph = ({ idLotes }) => {
  const [carregamentos, setCarregamentos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onInit = async () => {
      setLoading(true);

      try {
        const { data } = await apiNetCore.post(
          'demanda/obter-carregamento-dia',
          {
            idLotes,
          }
        );

        setCarregamentos(
          data.map(carregamento => ({
            ...carregamento,
            data: formatarData(carregamento.data),
          }))
        );
      } catch (e) {
        notification.error({
          message: 'Falha ao obter dados de carregamento.',
        });
      }

      setLoading(false);
    };

    onInit();
  }, [idLotes]);

  return (
    <Container>
      <h2>Carregamentos por dia</h2>
      {carregamentos?.length !== 0 ? (
        <>
          <LegendsContainer>
            <ChartLegend>
              <p>Volume carregado</p>
              <svg height="12" width="12">
                <circle cx="6" cy="6" r="6" fill="#24A96D" />
              </svg>
            </ChartLegend>
            {/* <ChartLegend>
              <p>Saldo</p>
              <svg height="12" width="12">
                <circle cx="6" cy="6" r="6" fill="#0D3549" />
              </svg>
            </ChartLegend> */}
          </LegendsContainer>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={carregamentos} width={500} height={400}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="data" xAxisId={0} />
              <XAxis dataKey="data" xAxisId={1} hide />
              <Tooltip />
              <Bar
                name="Valor no dia"
                dataKey="valorDia"
                unit=" ton"
                xAxisId={0}
                fill="#00AB55"
                barSize={30}
              />
              {/* <Bar name="Saldo" dataKey="saldo" xAxisId={0} fill="#0D3549" barSize={30} /> */}
              {/* <Bar
                name="Valor acumulado"
                dataKey="valorAcumulado"
                xAxisId={1}
                fill="#00AB55"
                barSize={30}
              /> */}
            </BarChart>
          </ResponsiveContainer>
        </>
      ) : (
        <NoDataContainer>
          {!loading && <h3>Não há dados de carregamento disponíveis</h3>}
        </NoDataContainer>
      )}
      {loading && (
        <LoadingContainer>
          <Spin />
        </LoadingContainer>
      )}
    </Container>
  );
};

CarregamentosGraph.propTypes = {
  idLotes: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default CarregamentosGraph;
